export function safeReturnTo(value: string | null | undefined): string {
  if (!value) return "/";

  let decoded = value;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    return "/";
  }

  if (
    !decoded.startsWith("/") ||
    decoded.startsWith("//") ||
    decoded.includes("\\") ||
    Array.from(decoded).some((character) => {
      const code = character.charCodeAt(0);
      return code < 32 || code === 127;
    })
  ) {
    return "/";
  }

  try {
    // URLSearchParams already decoded returnTo. Preserve encoded query values.
    const target = new URL(
      value.startsWith("/") ? value : decoded,
      window.location.origin,
    );
    return target.origin === window.location.origin
      ? `${target.pathname}${target.search}${target.hash}`
      : "/";
  } catch {
    return "/";
  }
}
